import dayjs from 'dayjs';
import GradationalSalary from './GradationalSalary.js';
import Job from './Job.js';
import SalaryIncreaseStep from './SalaryIncreaseStep.js';

export default class Grade {
  constructor(data) {
    this.id = data?.id;
    this.organizationId = data?.organizationId;
    this.name = data?.name;
    this.number = data?.number ? Number(data.number) : null;
    this.minSalary = data?.minSalary ? Number(data.minSalary) : null;
    this.maxSalary = data?.maxSalary ? Number(data.maxSalary) : null;
    this.salaryIncrementStep = data?.salaryIncrementStep ? Number(data.salaryIncrementStep) : null;
    this.annualRaiseEnabled = data?.annualRaiseEnabled ? Boolean(data.annualRaiseEnabled) : false;
    this.annualRaiseStep = data?.annualRaiseStep;
    this.isDeleted = data?.isDeleted ? Boolean(data.isDeleted) : false;
    this.createdAt = data?.createdAt ? dayjs(data.createdAt) : null;
    this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

    this.gradationalSalaries = data?.gradationalSalaries ? data?.gradationalSalaries.map(g => new GradationalSalary(g)) : [];
    this.jobs = data?.jobs ? data?.jobs.map(j => new Job(j)) : [];
    this.salaryIncreaseSteps = data?.salaryIncreaseSteps ? data?.salaryIncreaseSteps.map(s => new SalaryIncreaseStep(s)) : [];
  }
}
